import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _debounce from "lodash/debounce";
import { FormProvider, useForm } from "react-hook-form";
import moment from "moment";
import { joiResolver } from "@hookform/resolvers/joi";
import CrossIcon from "../../../../assets/icons/cross.svg";

import {
  fetchDebtLoadReportRequest,
  fetchDebtLoadReportSuccess,
} from "../../../../redux/actions/debtLoadAction";
import "./layoutDebtReport.scss";
import { DebtReportDataView } from "./DebtReportDataView";
import AppDatePicker from "../../DateRangePicker/AppDatePicker";
import { getDepartments } from "../../../../redux/actions/handbookAction";
import { DSelect, HCheckbox, HDatePicker, HRadio } from "../../../../validation/HForm";
import { REPORT_TYPE_MAPPING } from "../../../common/DebtLoadCalculation/constants/constants";
import DebtReportLoader from "./DebtReportLoader";
import { debtReportValidationSchema } from "./debtReportSchema";

const DEFAULT_REPORT_TYPE = "Проверить данные на текущий момент";

export const LayoutDebtReport = ({ onClose, title }) => {
  const dispatch = useDispatch();
  const { departments, loading } = useSelector(({ handbook }) => handbook);
  const { debtLoadReportData, debtReportLoading } = useSelector(({ debtLoad }) => debtLoad);
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [reportType, setReportType] = useState(REPORT_TYPE_MAPPING[DEFAULT_REPORT_TYPE]);

  const form = useForm({
    defaultValues: {
      departments: [],
      reportType: true,
      date: moment().format("YYYY-MM-DD"),
      dateRange: {
        startDate: moment(),
        endDate: moment(),
      },
    },
    resolver: joiResolver(debtReportValidationSchema),
  });

  const changeDataPicker = (values) => {
    setEndDate(values.endDate);
    setStartDate(values.startDate);
  };

  const handleGetDepartments = (e, action) => {
    if (action.action === "input-change") {
      e && dispatch(getDepartments(e));
    }
  };

  const debouncedGetDepartments = _debounce(handleGetDepartments, 250);

  const handleReportTypeChange = (e) => {
    setReportType(REPORT_TYPE_MAPPING[e.target.value]);
  };

  const onSubmit = (data) => {
    const cashBoxIds = data.departments.length ? data.departments.map(dep => dep.value) : [];
    const payload = {
      cashBoxIds,
    };

    switch (reportType) {
      case "current":
        payload.date = moment().format("YYYY-MM-DD");
        break;
      case "custom":
        payload.date = moment(data.date).format("YYYY-MM-DD");
        break;
      case "period":
        payload.dateFrom = startDate.format("YYYY-MM-DD");
        payload.dateTo = endDate.format("YYYY-MM-DD");
        break;
      case "all":
        payload.cashBoxIds = [];
      default:
        break;
    }
    dispatch(fetchDebtLoadReportRequest(payload));
  };

  useEffect(() => {
    return () => dispatch(fetchDebtLoadReportSuccess(null));
  }, []);

  return (
    <>
      <div className="modal-header flex-column">
        <div className="d-flex fullwidth">
          <h2 className="header-title">{title}</h2>
          <button
            className="button-icontrigger modal-closetrigger"
            onClick={onClose}
          >
            <span className="icon">
              <CrossIcon />
            </span>
          </button>
        </div>
      </div>

      <div className="modal-body">
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="form-row">
              <div className="form-row-item">
                <div className="form-element">
                  <label className="form-element-label">Подразделение</label>
                  <div className="form-element-data combobox departments">
                    <DSelect
                      classNamePrefix="select"
                      name="departments"
                      isMulti={true}
                      isLoading={loading}
                      options={departments}
                      placeholder="Введите подразделение"
                      noOptionsMessage={() => "Нет результатов"}
                      handleOptions={debouncedGetDepartments}
                      isSearchable={true}
                      closeMenuOnSelect={false}
                    />
                  </div>
                </div>
              </div>
              <div className="form-row-item">
                <div className="d-flex align-center h-100">
                  <HCheckbox
                    name="reportType"
                    className="input"
                    label="Все подразделения"
                  />
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-row-item">
                <div className="form-element">
                  <div className="date-selection-container">
                    <div className="radio-group">
                      <HRadio
                        labels={Object.keys(REPORT_TYPE_MAPPING)}
                        name="reportDateType"
                        checkboxStyle={true}
                        defaultCheckedLabel={DEFAULT_REPORT_TYPE}
                        onChange={handleReportTypeChange}
                      />
                    </div>

                    {reportType === "custom" && (
                      <div className="form-row flex-gap">
                        <HDatePicker
                          className="input block"
                          name="date"
                          defaultValue={moment().format("YYYY-MM-DD")}
                        />
                      </div>
                    )}
                    {reportType === "period" && (
                      <AppDatePicker
                        coverClass="form-element"
                        startDate={startDate}
                        endDate={endDate}
                        onChange={changeDataPicker}
                        resetPropsDate={changeDataPicker}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-row-item fullwidth">
                <div className="form-element">
                  {debtReportLoading && <DebtReportLoader/>}
                  {debtLoadReportData && (
                    <DebtReportDataView data={debtLoadReportData} loading={debtReportLoading}/>
                  )}
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-row-item">
                <button type="submit" className="button primary">
                  Сформировать отчет
                </button>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </>
  );
};
